import { useState, useEffect, useCallback } from "react";

interface WindowDimensions {
  width: number;
  height: number;
}

function getWindowDimensions(): WindowDimensions {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

interface Config {
  autoUpdateInterval: number | null;
}

const defaultConfig: Config = {
  autoUpdateInterval: 1000,
};

export default function useWindowDimensions(config: Partial<Config> = {}): WindowDimensions {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  config = { ...defaultConfig, ...config };

  const handleResize = useCallback(() => {
    setWindowDimensions(getWindowDimensions());
  }, [setWindowDimensions]);

  useEffect(() => {
    if (!config.autoUpdateInterval) {
      return;
    }

    const interval = setInterval(handleResize, config.autoUpdateInterval);
    return () => clearInterval(interval);
  }, [config.autoUpdateInterval, handleResize]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return windowDimensions;
}
